import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const MixtureListenIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-mixtureListen"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M10 7a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 2a6 6 0 1 1 0 12 6 6 0 0 1 0-12"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M8 12a2 2 0 0 1 1.995 1.85L10 14H9a1 1 0 0 0-1.993-.117L7 14H6a2 2 0 0 1 2-2m4 0a2 2 0 0 1 1.995 1.85L14 14h-1a1 1 0 0 0-1.993-.117L11 14h-1a2 2 0 0 1 2-2m-2 3a2 2 0 0 1 .15 3.995L10 19v-1a1 1 0 0 0 .117-1.993L10 16zm0 6a8 8 0 0 1 7.996 7.75L18 29h-2a6 6 0 0 0-11.996-.225L4 29H2a8 8 0 0 1 8-8M43 7a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 2a6 6 0 1 1 0 12 6 6 0 0 1 0-12"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M41 12a2 2 0 0 1 1.995 1.85L43 14h-1a1 1 0 0 0-1.993-.117L40 14h-1a2 2 0 0 1 2-2m4 0a2 2 0 0 1 1.995 1.85L47 14h-1a1 1 0 0 0-1.993-.117L44 14h-1a2 2 0 0 1 2-2m-2.5 3v1a1 1 0 0 0-.117 1.993L42.5 18v1a2 2 0 0 1-.15-3.995zm.5 6a8 8 0 0 1 7.996 7.75L51 29h-2a6 6 0 0 0-11.996-.225L37 29h-2a8 8 0 0 1 8-8"
        />
        <path
          fill="#0050B3"
          d="M25.707 22.707C28.28 20.543 30 17.407 30 14s-1.72-6.543-4.293-8.707c-.979-.824-2.4.584-1.414 1.414C26.475 8.542 28 11.09 28 14s-1.525 5.457-3.707 7.293c-.986.83.435 2.238 1.414 1.414"
        />
        <path
          className={styles.interactiveColor}
          d="M23.707 18.707C25.09 17.54 26 15.83 26 14s-.91-3.54-2.293-4.707c-.412-.348-1.01-.405-1.414 0-.358.357-.415 1.064 0 1.414.585.494.98.947 1.32 1.62.248.496.387 1.107.387 1.673a6 6 0 0 1-.02.456l-.017.103q-.024.128-.053.255a3.7 3.7 0 0 1-.274.81c-.34.696-.744 1.163-1.343 1.67-.413.347-.359 1.054 0 1.413.41.41 1 .35 1.414 0"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M58 7a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 2a6 6 0 1 1 0 12 6 6 0 0 1 0-12"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M56 12a2 2 0 0 1 1.995 1.85L58 14h-1a1 1 0 0 0-1.993-.117L55 14h-1a2 2 0 0 1 2-2m4 0a2 2 0 0 1 1.995 1.85L62 14h-1a1 1 0 0 0-1.993-.117L59 14h-1a2 2 0 0 1 2-2m-3.25 5.25a1 1 0 0 0 1.993.117l.007-.117h1a2 2 0 0 1-3.995.15l-.005-.15zM58 21a8 8 0 0 1 7.996 7.75L66 29h-2a6 6 0 0 0-11.996-.225L52 29h-2a8 8 0 0 1 8-8"
        />
      </g>
    </Icon>
  )
}
